import {Logger, silentLogger} from "@buildwithflux/logger";

const locationFallback = "https://flux.ai";

export function getLocationOrigin(logger: Logger = silentLogger) {
    try {
        return globalThis?.location?.origin || locationFallback;
    } catch (error) {
        /*
         * One reason this currently happens is: https://github.com/jsdom/jsdom/issues/2121
         * Despite the author's claim, I don't think this is fixed in JSDom 19+, or at least
         * it's not fixed if user code is badly behaved.
         *
         * The chain is like:
         * - We're in the middle of something (e.g. a routing test), and we have to do an async action.
         * - But don't await the Promise chain. Instead, we fire-and-forget it (this should be banned).
         * - Then the Jest test ends. The jsdom simulated document and window is shut down.
         * - But, some time later, that forgotten Promise bakes a node...
         *   - Which tries to get the execution context for expressions
         *   - Which tries to get the location origin
         *   - There is a window, and we've already captured it into our closure (when we defined getLocationOrigin())
         *     - But it was shut down already! *BOOM*
         */
        logger.warn("Error while getting location origin", error);

        return locationFallback;
    }
}

export function toAbsoluteUrl(relativeUrl: string): string {
    return new URL(relativeUrl, getLocationOrigin()).toString();
}

/**
 * WTF: this is not an HTTPS URL?
 */
export function toIframelyOembedUrl(absoluteUrl: string): string {
    return `http://flux.iframe.ly/api/oembed?url=${encodeURIComponent(absoluteUrl)}`;
}
